export { default } from './CuratedArticlesBlock';
export * from './CuratedArticlesBlock';
